import React, { useEffect, useState } from "react";
import { Button, TextField, Typography, Box, Card } from "@mui/material";
import Grid from "@mui/material/Grid2";
import useWindowSize from "../../../hooks/useWindowSize";
import { get, patch } from "../../../services/apiService";
import BackdropLoader from "../../../components/common/BackdropLoader";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";
import i18next from "i18next";

const ContactUsPreview = () => {
  const { currentLang } = useAuth();
  const { width } = useWindowSize();
  const [isLoading, setIsLoading] = useState(false);
  const [headingObj, setHeadingObj] = useState(null);
  const [heading, setHeading] = useState("");
  const direction = currentLang === "en" ? "ltr" : "rtl";
  const isArabic = i18next.language === "ar";
  const [headingError, setHeadingError] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const userId = localStorage.getItem("userId");
  const { id: userSectionId } = useParams();
  const [actualContent, setActualContent] = useState([]);
  console.log("actual content", actualContent);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (value.length > 0) {
      setHeadingError("");
    }
    if (name === "heading") {
      console.log("heading object inside handleChange---------->", headingObj);
      const updatedHeadingObj = headingObj.map((item) => ({
        ...item,
        translation: item.translation.map((trans) =>
          trans.languageCode === currentLang
            ? { ...trans, languageText: value }
            : trans,
        ),
      }));

      console.log("updated Heading Object--------->", updatedHeadingObj);
      setHeadingObj(updatedHeadingObj);
      setHeading(value);
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const onLoading = (isLoading) => {
    setIsLoading(isLoading);
  };

  const handleSave = async () => {
    if (heading) {
      const finalObject = {
        sectionContent: headingObj,
      };
      console.log("final object--------", finalObject);
      await patch(
        `users/${userId}/section/${userSectionId}/content`,
        finalObject,
        {},
        onLoading,
      );
    } else {
      setHeadingError("Heading is required.");
    }
  };

  const handleCancel = () => {
    // Handle cancel logic here
    setFormData({ name: "", email: "", message: "" });
  };

  const fetchContent = async () => {
    const response = await get(
      `users/${userId}/section/${userSectionId}`,
      {},
      onLoading,
    );
    const contentResponse = response?.data?.content;
    setActualContent(contentResponse);

    const requiredHeading = contentResponse[0]?.translation?.find(
      (trans) => trans.languageCode === currentLang,
    );
    console.log("content response----------->", contentResponse);
    console.log(
      "required heading------------->",
      requiredHeading?.languageText,
    );

    setHeadingObj(contentResponse);
    setHeading(requiredHeading?.languageText);
  };

  useEffect(() => {
    fetchContent();
  }, [currentLang]);

  // useEffect(()=>{
  //   console.log('heading', heading);
  //   console.log('heading obj', headingObj);
  // },[heading, headingObj])

  return (
    <Box p={1} dir={direction}>
      {/* Page Preview */}
      <Card
        sx={{ display: "flex", alignItems: "center", p: 2, marginTop: "1%" }}
      >
        <Box sx={{ borderRadius: "50%", marginRight: 2 }}>
          <Typography
            sx={{
              fontFamily: "Tajawal-Bold",
              color: "#0A0A0A",
              fontSize: width > 900 ? "26px" : "18px",
              fontWeight: 700,
            }}
          >
            {i18next.t("Contact Us Preview")}
          </Typography>
        </Box>
      </Card>
      {isLoading && <BackdropLoader />}
      <Card
        sx={{
          padding: "2%",
          marginBottom: "1%",
          backgroundColor: "#F7FAFE",
          borderRadius: "10px",
          marginTop: "1%",
        }}
      >
        <Grid container spacing={2}>
          {/* Left - Heading */}
          <Grid item size={{ md: 5, sm: 12 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Tajawal-Bold",
                  color: "#2E2E2E",
                  textAlign: "center",
                  fontSize: width > 900 ? "26px" : "18px",
                }}
              >
                {heading}
              </Typography>
            </Box>
          </Grid>

          {/* Right - Form */}
          <Grid item size={{ md: 7, sm: 12 }} sx={{ width: "100%" }}>
            <Box
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                padding: "1rem",
                // border: "1px solid #ccc",
                // borderRadius: "8px",
              }}
            >
              <TextField
                placeholder={i18next.t("Name")}
                variant="outlined"
                fullWidth
                disabled={true}
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
              <TextField
                placeholder={i18next.t("Email")}
                variant="outlined"
                fullWidth
                name="email"
                disabled={true}
                value={formData.email}
                onChange={handleChange}
              />
              <TextField
                placeholder={i18next.t("Message")}
                variant="outlined"
                fullWidth
                name="message"
                disabled={true}
                value={formData.message}
                onChange={handleChange}
                multiline
                rows={4}
              />
            </Box>
          </Grid>
        </Grid>
      </Card>

      {/* Heading and Save/Cancel Buttons */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          marginTop: width > 450 ? "2%" : "8%",
        }}
      >
        <TextField
          placeholder="Update Heading"
          variant="outlined"
          fullWidth
          value={heading}
          name="heading"
          onChange={handleChange}
        />
        {headingError && (
          <Typography
            sx={{
              fontFamily: "Tajawal-Regular",
              color: "red",
              textAlign: "center",
              fontSize: "14px",
            }}
          >
            {i18next.t(headingError)}
          </Typography>
        )}

        <Box justifyContent="center" textAlign="center">
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#3173B1",
              color: "white",
              width: width > 450 ? "10%" : "30%",
              fontWeight: "bold",
              "&:hover": { backgroundColor: "#3173B1" },
            }}
            onClick={handleSave}
          >
            {i18next.t("Save Changes")}
          </Button>

          <Button
            variant="outlined"
            sx={{
              borderColor: "black",
              color: "black",
              fontWeight: "bold",
              width: width > 450 ? "10%" : "30%",
              marginLeft: !isArabic && "1%",
              marginRight: isArabic && "1%",
              "&:hover": { backgroundColor: "#f2f2f2" },
            }}
            onClick={handleCancel}
          >
            {i18next.t("Cancel")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ContactUsPreview;
